import fallback from './fallback'
import default_th from './th'
import default_en from './en'

export const localeDefaultFunc: Record<string, any> = {
  th: default_th,
  en: default_en,
  fallback: fallback
}
